









































































import useBreakpoints from '@getaccept/lib-shared/src/composables/breakpoints.composable';
import CommentHistory from '@getaccept/lib-shared/src/contextual-commenting/components/CommentHistory.vue';
import { useContextualCommentingStore } from '@getaccept/lib-shared/src/contextual-commenting/store/contextual-commenting.store';
import type { CreateReplyInput } from '@getaccept/lib-shared/src/contextual-commenting/types/create-reply-input';
import type { CurrentUser } from '@getaccept/lib-shared/src/contextual-commenting/types/current-user';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import { ButtonType } from '@getaccept/lib-ui';
import type { PropType, Ref } from '@vue/composition-api';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import type { CommentParticipant } from '@getaccept/lib-shared/src/contextual-commenting/types/comment-participant';
import { useContextualCommentingData } from '../composables/contextual-commenting-data.composable';

export default defineComponent({
  components: {
    CommentHistory,
  },
  props: {
    recipients: {
      type: Array as PropType<Recipient[]>,
      required: true,
    },
    sender: {
      type: Object as PropType<User>,
      required: true,
    },
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    preventCommentsModification: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { recipient }: { recipient: Ref<SigningPageRecipient> } = toRefs(props);

    const { updateComment, createReply, selectComment } = useContextualCommentingData();
    const { isXSmallScreenAndUp, isXSmallScreenAndDown } = useBreakpoints();

    const handleCreateReply = (payload: CreateReplyInput) => {
      const currentUser: CommentParticipant = { userId: null, recipientId: recipient.value.id };
      createReply(payload, currentUser);
    };

    const store = useContextualCommentingStore();

    const {
      commentHistoryComments: comments,
      selectedCommentId,
      hoveredCommentId,
      isCommentHistoryOpen,
      commentsHidden,
    } = storeToRefs(store);

    const currentUser = computed<CurrentUser>(() => ({
      recipientId: recipient.value.id,
      name: recipient.value.fullName,
      thumbUrl: recipient.value.thumbUrl,
    }));

    const isSelected = (commentId: string) => commentId === selectedCommentId.value;

    const select = (commentId: string) => {
      if (isSelected(commentId)) {
        return;
      }
      hide();
      selectComment(commentId, props.recipient.id);
    };

    const handleClickOutside = (commentId: string) => {
      const ignoreClickOutside = !isSelected(commentId) || !isCommentHistoryOpen.value;
      if (ignoreClickOutside) {
        return;
      }

      select('');
    };

    const hide = () => {
      store.toggleCommentHistory(false);
    };

    const goToComment = (commentId: string) => {
      emit('go-to-comment', commentId);
      hide();
    };

    const toggle = () => {
      store.toggleCommentHistory(!isCommentHistoryOpen.value);
    };

    return {
      select,
      updateComment,
      handleCreateReply,
      toggle,
      goToComment,
      t,
      hide,
      handleClickOutside,
      toggleComments: store.toggleHideComments,

      ButtonType,
      comments,
      currentUser,
      selectedCommentId,
      hoveredCommentId,
      isCommentHistoryOpen,
      isXSmallScreenAndUp,
      isXSmallScreenAndDown,
      commentsHidden,
    };
  },
});
